import { render } from "./PaginationByConfirmLotto.vue?vue&type=template&id=47217653&scoped=true"
import script from "./PaginationByConfirmLotto.vue?vue&type=script&lang=js"
export * from "./PaginationByConfirmLotto.vue?vue&type=script&lang=js"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47217653"]])

export default __exports__